<div class="layout">
  <aside class="left-nav">
    <app-side-nav></app-side-nav>
  </aside>
  <main>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    <app-toast-container></app-toast-container>
  </main>
</div>
